import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonDataType } from '@models/common';
import {
  CreateDocumentRequest,
  CreateDocumentResponse,
  Document,
  DocumentCommonDataObject,
  DocumentDownloadResponse,
  DocumentListItem,
  NewFileUploadResponse,
  UpdateDocumentRequest,
} from '@models/documents';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class DocumentsService {
  private readonly url = `${environment.bffUrl}/documents`;

  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<DocumentListItem[]> {
    return this.httpClient.get<DocumentListItem[]>(this.url);
  }

  getOne(id: string): Observable<Document> {
    return this.httpClient.get<Document>(`${this.url}/${id}`);
  }

  update(id: string, doc: UpdateDocumentRequest): Observable<Document> {
    return this.httpClient.put<Document>(`${this.url}/${id}`, doc);
  }

  add(document: CreateDocumentRequest): Observable<CreateDocumentResponse> {
    return this.httpClient.post<CreateDocumentResponse>(this.url, document);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}`);
  }

  updateCommonData(id: string, type: CommonDataType, data: DocumentCommonDataObject[]): Observable<Document> {
    return this.httpClient.put<Document>(`${this.url}/${id}/common-data`, { type, data });
  }

  uploadNewFileToExistingDoc(id: string, fileName: string): Observable<NewFileUploadResponse> {
    return this.httpClient.post<NewFileUploadResponse>(`${this.url}/${id}/upload-file`, { fileName });
  }

  publish(id: string): Observable<Document> {
    return this.httpClient.post<Document>(`${this.url}/${id}/publish`, null);
  }

  unpublish(id: string): Observable<Document> {
    return this.httpClient.post<Document>(`${this.url}/${id}/unpublish`, null);
  }

  download(id: string): Observable<DocumentDownloadResponse> {
    return this.httpClient.get<DocumentDownloadResponse>(`${this.url}/${id}/download`);
  }
}
